function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { Html } from "@custom/schema";
import React from "react";
import { LinkedInFeedbackForm } from "./LinkedInFeedbackForm";
export function MarkupText(_param) {
    var _param_tableVariant = _param.tableVariant, tableVariant = _param_tableVariant === void 0 ? "nested" : _param_tableVariant, props = _object_without_properties(_param, [
        "tableVariant"
    ]);
    return /*#__PURE__*/ React.createElement(Html, _object_spread_props(_object_spread({}, props), {
        components: {
            table: function(param) {
                var children = param.children;
                return /*#__PURE__*/ React.createElement(React.Fragment, null, tableVariant === "nested" ? /*#__PURE__*/ React.createElement("div", {
                    className: "overflow-x-auto mb-[1.875rem] w-full"
                }, " ", /*#__PURE__*/ React.createElement("table", null, children)) : /*#__PURE__*/ React.createElement("div", {
                    className: "overflow-x-auto mb-[1.875rem] w-full"
                }, /*#__PURE__*/ React.createElement("table", null, children)));
            },
            div: function(_param) {
                var children = _param.children, id = _param.id, props = _object_without_properties(_param, [
                    "children",
                    "id"
                ]);
                if (id === "one-click-feedback-widget-form-wrapper") {
                    return /*#__PURE__*/ React.createElement(LinkedInFeedbackForm, null);
                }
                return /*#__PURE__*/ React.createElement("div", _object_spread({
                    id: id
                }, props), children);
            }
        }
    }));
}
